import type { Slide, SlidePosition } from "@hali-shares/deck-schema";

function stopsOf(slide: Slide | undefined): number {
  return slide?.kind === "block" ? slide.stops : 1;
}

export function clamp(slides: Slide[], pos: SlidePosition): SlidePosition {
  const slideIndex = Math.min(Math.max(0, Math.trunc(pos.slideIndex) || 0), slides.length - 1);
  const stop = Math.min(Math.max(0, Math.trunc(pos.stop) || 0), stopsOf(slides[slideIndex]) - 1);
  return { slideIndex, stop };
}

/** Next stop: zoom into the next node / next pin, else the next slide. Stays put at the end. */
export function next(slides: Slide[], pos: SlidePosition): SlidePosition {
  if (pos.stop + 1 < stopsOf(slides[pos.slideIndex])) return { slideIndex: pos.slideIndex, stop: pos.stop + 1 };
  if (pos.slideIndex + 1 < slides.length) return { slideIndex: pos.slideIndex + 1, stop: 0 };
  return pos;
}

/**
 * Previous stop. Within a slide it steps back through the zooms or pins; stepping back onto the previous
 * slide lands on its overview (stop 0), never mid-zoom, so the main flow is always one key away.
 */
export function prev(slides: Slide[], pos: SlidePosition): SlidePosition {
  if (pos.stop > 0) return { slideIndex: pos.slideIndex, stop: pos.stop - 1 };
  if (pos.slideIndex > 0) return { slideIndex: pos.slideIndex - 1, stop: 0 };
  return pos;
}

export function samePosition(a: SlidePosition, b: SlidePosition): boolean {
  return a.slideIndex === b.slideIndex && a.stop === b.stop;
}
